import React from 'react';
import { Link } from 'react-router-dom';
import packageJson from '../package.json';
import { useLocation } from 'react-router-dom';
import ComNavbarToggler from './pages/components/comNavbarToggler';
import confetti from 'canvas-confetti';
import { auth } from './helper/helperFirebaseAuth';
import { signOut } from 'firebase/auth';
import { useAuth } from './pages/components/authProvider';


const SiteLayout = ({ children }) => {
    const { authUser } = useAuth();
    const location = useLocation();
    const currentPath = location.pathname + location.hash;
    const menuItems = [
        { name: "Home", path: "/" },
        { name: "Features", path: "#features" },
        { name: "Pricing", path: "#pricing" },
        { name: "Blog", path: "/blog" },
        { name: "Contact", path: "#contact" },
    ];
    const footerMenuItems = [
        { target: "_self", name: "Home", path: "/" },
        { target: "_self", name: "Features", path: "#features" },
        { target: "_self", name: "Pricing", path: "#pricing" },
        { target: "_self", name: "Contact", path: "#contact" },
        { target: "_self", name: "Brand Guidelines", path: "/brand-guidelines" },
    ];
    const footerSocialLinks = [
        { name: "LinkedIn", url: "https://www.linkedin.com/company/SparklingEmail/", icon: "fab fa-linkedin" },
        { name: "X (Twitter)", url: "https://x.com/SparklingEmail", icon: "fab fa-twitter" },
    ];
    const footerContactLinks = [
        { name: "Sparkling Support Email", url: "mailto:support@sparklingemail.com", label: "Support Team", icon: "far fa-envelope" },
        { name: "Sparkling Contact Email", url: "mailto:info@sparklingemail.com", label: "General Inquiries", icon: "far fa-envelope" },
    ];
    const isDashboard = (currentPath.includes('/app'));
    const isAuthenticated = !!authUser && !!authUser?.email && authUser?.emailVerified;

    React.useEffect(() => {
        const links = document.querySelectorAll('.sparklingemail-confetti');

        const handleMouseEnter = (e) => {
            const x = e.clientX / window.innerWidth;
            const y = e.clientY / window.innerHeight;
            confetti({
                origin: { x, y },
                particleCount: 80,
                spread: 70,
                startVelocity: 30,
            });
        };

        links.forEach(link => {
            link.addEventListener('mouseenter', handleMouseEnter);
        });

        return () => {
            links.forEach(link => {
                link.removeEventListener('mouseenter', handleMouseEnter);
            });
        };
    }, []);

    // Handle logout
    const handleLogout = async () => {
        await signOut(auth);
        window.location.href = '/';
    };

    return <>
        {/* Maintenance Banner*/}
        {/* <div className="bg-danger text-dark text-center py-2 fw-semibold fs-7">
            ⚠️ Scheduled Maintenance: Some features may be unavailable today (June 11, 2025)
        </div> */}
        {/* Header */}
        <header
            id="home"
            className="container-fluid border-bottom border-light border-1 m-0 p-0"
        >
            <div className={isDashboard ? 'container-fluid ps-3 pe-5 bg-light' : "container"}>
                <nav className="navbar navbar-expand-xl navbar-light p-0 fs-6 fw-normal pb-4 pb-xl-0">
                    {/* Header/Logo */}
                    <Link
                        className="navbar-brand p-0 d-flex align-items-center text-dark text-decoration-none"
                        to="/"
                        title="Sparkling Email"
                        aria-label="Sparkling Email"
                    >
                        <img
                            src="/logo.png"
                            alt="Sparkling Email Logo"
                            className="p-1 mr-2"
                            width="72px"
                            height="72px"
                            style={{ objectFit: 'scale-down' }}
                        />
                        <div className="text-dark fs-1 pt-1 fw-semibold">Sparkling Email</div>
                    </Link>

                    {/* Header/Mobile Toggler - Only visible on mobile */}
                    <ComNavbarToggler className="navbar-toggler d-xl-none me-4" />

                    {/* Header/Navbar links */}
                    <div className="collapse navbar-collapse justify-content-end ps-3" id="navbarNav">
                        <ul className="navbar-nav">
                            {menuItems.map((item, index) => (
                                <li key={index} className="nav-item me-3">
                                    <Link
                                        className={`nav-link ${currentPath.includes(item.path) ? "text-dark" : "text-secondary"} hover:text-dark`}
                                        to={item.path}
                                        title={item.name}
                                        aria-label={item.name}
                                    >
                                        {item.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>

                        {/* Header Login Button */}
                        {isAuthenticated && <>
                            <Link
                                className="d-block d-md-none btn p-0 border-0"
                                style={{ width: '32px', height: '32px' }}
                                to="/app/profile"
                            >
                                <img
                                    src={authUser.photoURL}
                                    alt="profile picture"
                                    className="rounded-circle"
                                    style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                                />
                            </Link>
                            <div className="d-none d-md-block nav-item dropdown ms-3">
                                <button
                                    className="btn p-0 border-0"
                                    id="userDropdown"
                                    data-bs-toggle="dropdown"
                                    aria-expanded="false"
                                    style={{ width: '32px', height: '32px' }}
                                >
                                    <img
                                        src={authUser.photoURL}
                                        alt="profile picture"
                                        className="rounded-circle"
                                        style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                                    />
                                </button>
                                <ul
                                    className="dropdown-menu dropdown-menu-end mt-2"
                                    aria-labelledby="userDropdown"
                                    style={{ minWidth: '210px' }}
                                >
                                    <li className="px-3 py-2">
                                        <div className="fw-medium">{authUser.displayName}</div>
                                        <div className="text-muted small">{authUser.email}</div>
                                    </li>
                                    <li>
                                        <hr className="dropdown-divider" />
                                    </li>
                                    <li>
                                        <Link className="dropdown-item" to="/app/profile">Profile</Link>
                                    </li>
                                    <li>
                                        <a className="dropdown-item" href="/policies">Terms &amp; policies</a>
                                    </li>
                                    <li>
                                        <button className="dropdown-item" onClick={handleLogout}>Log out</button>
                                    </li>
                                </ul>
                            </div>
                        </>}
                        {!isAuthenticated && <Link className="btn btn-gold mt-3 mt-xl-0" to="/app" aria-label="App" >Try it Free</Link>}
                    </div>
                </nav>
            </div >
        </header >

        {/* Main content */}
        {children}

        {/* Footer */}
        <footer id="contact" className="container-fluid border-top border-light border-1 bg-dark text-light py-4">
            <div className="container">
                <div className="row mb-4">
                    <div className="col-12 col-xl-5">
                        <div className="d-flex align-items-center mb-3">
                            <img
                                src="/logo.png"
                                alt="Sparkling Email Logo"
                                className="p-1 me-2"
                                width="72px"
                                height="72px"
                                style={{
                                    objectFit: 'scale-down',
                                    filter: 'brightness(10000%) grayscale(100%) contrast(0%)'
                                }}
                            />
                            <div className="text-white-50 fs-2 fw-semibold sparklingemail-confetti">Sparkling Email</div>
                        </div>
                        <p className="text-white-50 fs-8 fw-light text-secondary mt-1">
                            Enterprise Email Auto-Translation & Smart Signatures Email Tools for Microsoft 365, Google Workspace & Zoho Mail.
                            Server‑side, real‑time email translation built for bilingual Canadian (English‑French) companies,
                            multilingual workplace and smart signatures, analytics & compliance.
                            Integrates seamlessly with Microsoft 365 Exchange Admin Center, Google Workspace, and Zoho.
                            No plugins required. 100 % server‑side, no browser add‑ons or plugins or extensions needed.
                            Boost email compliance & brand consistency, streamline multilingual communications, and simplify IT management.
                            Unify multilingual emails, start your Sparkling Email today!
                        </p>
                    </div>
                    <div className="col-4 col-xl-2 pe-0">
                        <h2 className="fs-6 text-white-50 fw-semibold my-2">Quick Links</h2>
                        <ul className="fs-7 list-unstyled mt-3">
                            {footerMenuItems.map((item, index) => (
                                <li key={index}>
                                    <small>
                                        <Link
                                            className="text-white-50 hover:text-light text-decoration-none mb-2 d-block"
                                            to={item.path}
                                            target={item.target}
                                            rel={item.target === "_blank" ? "noreferrer" : undefined}
                                            title={item.name}
                                            aria-label={item.name}
                                        >
                                            {item.name}
                                        </Link>
                                    </small>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="col-4 col-xl-2 pe-0">
                        <h2 className="fs-6 text-white-50 fw-semibold my-2">Social Media</h2>
                        <ul className="fs-7 list-unstyled mt-3">
                            {footerSocialLinks.map((item, index) => (
                                <li key={index}>
                                    <small>
                                        <a
                                            className="text-white-50 hover:text-light text-decoration-none mb-2 d-block no-wrap"
                                            href={item.url}
                                            title={"Sparkling Email " + item.name}
                                            aria-label={"Sparkling Email " + item.name}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            <i className={`${item.icon} me-2`}></i>{item.name}
                                        </a>
                                    </small>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="col-4 col-xl-3 pe-0">
                        <h2 className="fs-6 text-white-50 fs-5 fw-semibold my-2">Contact</h2>
                        <ul className="fs-7 list-unstyled mt-3">
                            {footerContactLinks.map((item, index) => (
                                <li key={index}>
                                    <small>
                                        <a
                                            className="text-white-50 hover:text-light text-decoration-none mb-2 d-block no-wrap"
                                            href={item.url}
                                            title={item.name}
                                            aria-label={item.name}
                                        >
                                            {item.icon && <i className={item.icon + " me-2"}></i>}
                                            {item.img && <img src={item.img} alt={item.name} width="18" height="18" />}
                                            {item.label}
                                        </a>
                                    </small>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
            <div className="text-white-50 text-center fs-7 fw-light mb-4 mb-lg-0">
                <small>
                    &copy; 2024 - {new Date().getFullYear()}
                    <span className='sparklingemail-confetti ms-1'>Sparkling Email</span>.
                    All rights reserved.
                    <br />
                    Made with
                    <span
                        className='mx-1'
                        style={{
                            display: 'inline-block',
                            animation: 'pulse 5s infinite ease-in-out',
                        }}
                    >❤️</span>
                    in Toronto. v{packageJson.version}</small>
            </div>
        </footer>
    </>
};

export default SiteLayout;